import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import CreaInformacionLiderSolocitud from "../Modals/crear/CreaInformacionLiderSolicitud";
import { obtenerLiderSolicitudes } from "../../Services/Rest";
import Cookies from "universal-cookie";
import AutoevaluacionOm from "./AutoevaluacionOmG";

function InfoAutoevaluacionOmG(props) {
  const [postEstado, setPostEstado] = useState(props.idTitulo);
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOmAsistencial?Titulo=" +
        props.idTitulo +
        "&SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      //'https://suadesarrollo.azurewebsites.net/api/ObtenerOmApoyo?Titulo='+props.idTitulo+'&SolicitudId='+props.idSolicitud

      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOmAsistencial?Titulo=" +
        postEstado +
        "&SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  const handlecountry = (event) => {
    axios({
      method: "get",
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOmAsistencial?Titulo=" +
        postEstado +
        "&SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
    const EStadoId = event.target.value;
    setPostEstado(EStadoId);
  };
  const BusacarPorEstado = () => {
    axios
      .get(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerOmAsistencial?Titulo=" +
          postEstado +
          "&SolicitudId=" +
          props.idSolicitud,
      )
      .then((response) => {
        setList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  INFORMACIÓN OPORTUNIDADES DE MEJORA
                </h6>
              </div>
              <div class="card-body">
                <AutoevaluacionOm
                  idSolicitud={props.idSolicitud}
                  idTitulo={props.idTitulo}
                />
                <select
                  className="btn btn-secondary btn-user btn-block text-left"
                  onChange={(e) => handlecountry(e)}
                >
                  <option value="">seleccione</option>
                  <option value="34">Om Humanización atención </option>
                  <option value="35">Om seguridad del paciente </option>
                  <option value="36">Om Gestion tecnologia </option>
                  <option value="37">Om Enfoque gestion de riesgo </option>
                  <option value="38">Om Transformacion cultural </option>
                  <option value="39">Om Responsabilidad social </option>
                  <option value="40">
                    Om Procesode atención al cliente asistencial ambulatorio y
                    hospitalario{" "}
                  </option>
                  <option value="41">Om Mejoramiento de la calidad </option>
                </select>
                <button
                  className="btn btn-primary btn-user btn-block"
                  onClick={(e) => BusacarPorEstado(handlecountry(e))}
                >
                  buscar
                </button>

                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>OM</th>
                        <th>Texto</th>
                        <th>Acciones de mejora implementadas </th>
                        <th>Elemento de verificacion</th>
                        <th>titulo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.numeroOm}</td>
                            <td>{item.texto}</td>
                            <td>{item.accion}</td>
                            <td>{item.elementoVerificacion}</td>
                            <td>{item.titulo}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default InfoAutoevaluacionOmG;
